import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Modal } from 'react-bootstrap';

import './themeModal.scss';

class ThemeModal extends Component {
  render() {
    const { show = true, children, title, isBack, history } = this.props;
    return (
      <Modal className="theme-modal" show={show}>
        <div className="theme-header">
          <div className="theme-header-upper">
            <div className="theme-header-left">
              {isBack && (
                <div onClick={() => history.goBack()}>
                  <img src="/img/left-icon.svg" alt="back" />
                </div>
              )}
            </div>
            <div className="theme-header-center">
              <img src="/img/mohan.svg" alt="logo" />
            </div>
            <div className="theme-header-right">
              {/* <img src="/img/close-icon.svg" alt="close" /> */}
            </div>
          </div>
          <div className="theme-header-lower">{title}</div>
        </div>
        <div>{children}</div>
      </Modal>
    );
  }
}

export default withRouter(ThemeModal);
